import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom"; // Add useLocation
import { Container, Typography, Grid, AppBar, Box, Modal, Paper, Toolbar, TextField, Button } from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditOrganization = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  let navigate = useNavigate();
  const { organisationId } = useParams();
  const location = useLocation(); // Access navigation state
  const [formData, setFormData] = useState({
    organisationName: "",
    email: "",
    mobileNo: "",
    landlineNo: "",
    address: "",
    zipCode: "",
    fax: "",
    website: "",
  });
  const [loadingBarProgress, setLoadingBarProgress] = useState("");

  useEffect(() => {
    const fetchOrganizationDetails = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const response = await fetch(`${apiUrl}/Organization/GetOrganization`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
        });

        if (response.ok) {
          const data = await response.json();
          const organization = data.find(
            (org) => org.schoolId === parseInt(organisationId)
          );
          if (organization) {
            setFormData({
              organisationName: organization.schoolName,
              email: organization.email,
              mobileNo: organization.mobileNo,
              landlineNo: organization.phoneNo,
              address: organization.address,
              zipCode: "",
              fax: "",
              website: "",
            });
          }
        } else {
          console.error("Failed to fetch organization details");
        }
      } catch (error) {
        console.error("API request error:", error);
      }
    };

    fetchOrganizationDetails();
  }, [organisationId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(
        `${apiUrl}/Organization/OrgId?OrganizationId=${organisationId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          body: JSON.stringify({
            OrganisationName: formData.organisationName,
            email: formData.email,
            MobileNo: formData.mobileNo,
            LandlineNo: formData.landlineNo,
            address: formData.address,
            zipCode: formData.zipCode,
            fax: formData.fax,
            website: formData.website,
          }),
        }
      );

      if (response.ok) {
        setLoadingBarProgress(100);
        // alert("Details Updated Successfully");
        setShowSuccessModal(true);

        // Navigate back to Organization.js with encodedFormId
        const encodedFormId = location.state?.encodedFormId;
        if (encodedFormId) {
          // navigate(-1);
        } else {
          // navigate(-1); // Fallback to default if not provided
        }
      } else {
        setLoadingBarProgress(0);
        // alert("Error Updating Details");
        setSnackbarMessage('Error Updating Details');
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("API request error:", error);
    }
  };

  const handleCancel = () => {
    const encodedFormId = location.state?.encodedFormId;
    if (encodedFormId) {
      navigate(-1);
    } else {
      navigate(-1); // Fallback to default if not provided
    }
  };

  return (
    <Container>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit Organization
          </Typography>
        </Toolbar>
      </AppBar>

      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Organization Name"
                variant="outlined"
                name="organisationName"
                value={formData.organisationName}
                placeholder="Enter organization name"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="email"
                label="Email"
                variant="outlined"
                name="email"
                value={formData.email}
                placeholder="Enter email"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="tel"
                label="Mobile No."
                variant="outlined"
                name="mobileNo"
                value={formData.mobileNo}
                placeholder="Enter mobile number"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="tel"
                label="Landline No."
                variant="outlined"
                name="landlineNo"
                value={formData.landlineNo}
                placeholder="Enter landline number"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Address"
                variant="outlined"
                name="address"
                value={formData.address}
                placeholder="Enter address"
                onChange={handleChange}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="text"
                label="Zip Code"
                variant="outlined"
                name="zipCode"
                value={formData.zipCode}
                placeholder="Enter zip code"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="text"
                label="Fax"
                variant="outlined"
                name="fax"
                value={formData.fax}
                placeholder="Enter fax number"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="text"
                label="Website"
                variant="outlined"
                name="website"
                value={formData.website}
                placeholder="Enter website URL"
                onChange={handleChange}
              />
            </Grid> */}
          </Grid>
          <div style={{ marginTop: "16px", display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="button"
              variant="contained"
              color="primary"
              size="large"
              onClick={handleUpdate}
            >
              Update
            </Button>
            <Button
              type="button"
              variant="contained"
              color="error"
              size="large"
              onClick={handleCancel}
              style={{ marginLeft: "8px" }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Subject Added ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Organization Details Updated Successfully
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default EditOrganization;
